import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import ReactModal from 'react-modal';
import moment from 'moment';
import _cloneDeep from 'lodash/cloneDeep';

import {Message} from '../utilites';
import {
  DocumentsAdd,
  DocumentsView,
  ContactsAdd,
  EmployerAdd,
  VisaAdd,
  ClientInfoAdd,
  AddressView,
  ContactView,
  EmployerView,
  VisaView,
  NamesView,
  NamesAdd,
  IEView,
  IEAdd,
  AddressShortAdd,
  ServiceInfoView,
  DecisionMakersInfoAdd,
  DecisionMakersInfoView,
  ServiceInformationModal,
} from '../utilites/Forms';
import {DSelect, HCheckbox, HInput, HookForm, HSelect, HTextarea} from '../../validation/HForm';
import {createClientScheme} from '../../validation/scheme/clientScheme';
import clientDocumentScheme from '../../validation/scheme/clientDocumentScheme';
import clientAddressScheme from '../../validation/scheme/clientAddressScheme';
import clientContactScheme from '../../validation/scheme/clientContactScheme';
import clientEmployerScheme from '../../validation/scheme/clientEmployerScheme';
import clientVisaScheme from '../../validation/scheme/clientVisaScheme';
import clientNamesScheme from '../../validation/scheme/clientNamesScheme';
import clientIEScheme from '../../validation/scheme/clientIEScheme';
import { clientDecisionMakersInfoScheme } from '../../validation/scheme/clientDecisionMakersInfoScheme';
import {defaultCategories, hearAboutTypes} from '../../helpers/data-constants';
import FormElementsAdd from '../utilites/Forms/FormElementsAdd';
import { transformServiceData } from '../utilites/Forms/ServiceInformation/utils';
import {BackButton} from '../common';
import {clearCondition, addClient, getCountry} from '../../redux/actions/clientAddAction';
import CriminalsInfo from './CriminalsInfo/CriminalsInfo';
import s from './CriminalsInfo/CriminalInfo.module.scss';
import {resetSearch} from '../../redux/actions/searchAction';

import './client-add.scss';
import '../../assets/styles/components/_tables.scss';
import '../../assets/styles/components/_content-card.scss';
import '../../assets/styles/components/_content-tabs.scss';
import '../../assets/styles/components/_collapse.scss';
import '../../assets/styles/components/_modal.scss';

import EditIcon from '../../assets/icons/edit.svg';
import TrashIcon from '../../assets/icons/trash.svg';
import PlusIcon from '../../assets/icons/plus-small.svg';
import CrossIcon from '../../assets/icons/cross.svg';
import ClientAddLoader from './Loader/ClientAddLoader';
import Loader from "../Users/Loader/Loader";
import { CLIENT_FIELDS } from '../utilites/Forms/ServiceInformation/constants';

const ClientAdd = ({setTitlePage}) => {
  const {loading, commonError, isBack, country, isLoading, client} = useSelector(
    ({clientAdd}) => clientAdd,
  );

  const {criminalResults, commonError: searchError} = useSelector(({search}) => search);
  const {accessFeatures, isLoadingConfiguration} = useSelector(({user}) => user);
  const defaultClientCategories = defaultCategories.slice(0, -1)

  const dispatch = useDispatch();
  const [state, setState] = useState({
    showModalDocs: false, showModalAddresses: false,
    showModalServiceInformation: false,
    showModalDecisionMakersInfo: false,
    showModalContacts: false,
    showModalEmployer: false,
    showModalVisa: false,
    showModalRepresentative: false,
    showModalPreviousSurname: false,
    showModalIE: false,
    tempEntity: {},
    documents: [],
    serviceInformation: [],
    decisionMakersInfo: [],
    addresses: [],
    employers: [],
    categories: {},
    representatives: [],
    previousLastNames: [],
    entryVisas: [],
    individualEntrepreneurs: [],
    contacts: [],
    tempEntityShort: {},
    addressTabIndex: 1,
  });
  const [description, setDescription] = useState(null);
  const history = useHistory();
  const combineError = commonError || searchError;
  const aimAndRelationshipFeature = accessFeatures['client.aim_and_relationship']

  useEffect(() => {
    accessFeatures['title.header_section'] && setTitlePage('Добавление клиента');
  }, [isLoadingConfiguration]);

  useEffect(() => {
    if (isBack) {
      if (history.location?.state?.isQuickCalculation) {
        dispatch(clearCondition());
        history.push({
          pathname: `/client/${client.id}/contract`,
          state: {isQuickCalculation: true},
        });
      } else {
        dispatch(clearCondition());
        history.push(`/client/${client.id}`);
      }
    }
  }, [isBack, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetSearch());
    };
  }, []);

  useEffect(() => {
      dispatch(clearCondition());
  }, []);


  const onSubmit = (form) => {
    const newForm = _cloneDeep(form)
    if (accessFeatures['client.category']) {
      newForm.client.categories = (!newForm?.client?.categories?.value) ? [] : [newForm?.client?.categories?.value]
    }
    let updatedState = { ...state };

    updatedState = {
      ...updatedState,
      serviceInformation: state.serviceInformation.length ? transformServiceData(state.serviceInformation[0]) : undefined,
    };
    
    history.location?.state?.isQuickCalculation
      ? dispatch(addClient(newForm, updatedState, true))
      : dispatch(addClient(newForm, updatedState, false));
  };

  const handleEditEntity = (listName, index) => {
    let entity = state[listName][index];
    for (let prop in entity) {
      if (entity.hasOwnProperty(prop)) {
        if (entity[prop] instanceof Date) {
          entity[prop] = moment(entity[prop])
            .utcOffset(0, true)
            .toISOString()
            .substr(0, 10);
        }
      }
    }
    entity.index = index;
    if (listName === 'addresses') {
      let temp = _cloneDeep(entity);
      let tempShort = _cloneDeep(entity);
      if (entity.region?.label) {
        //stored as short
        temp.region = entity.region?.label;
        temp.city = entity.city?.name;
        temp.street = entity.street?.name;
      } else {
        //stored as full
        tempShort.region = {
          label: entity.region,
          value: entity.region,
        };
        tempShort.city = {
          label: entity.cityType + ' ' + entity.city,
          value: entity.cityType + ' ' + entity.city,
          name: entity.city,
        };
        const street = `${entity.streetType === '-' ? '' : `${entity.streetType} `}${
          entity.street
        }`;
        tempShort.street = {
          label: street,
          value: street,
          name: entity.street,
        };
      }
      setState((prev) => ({
        ...prev,
        tempEntity: temp,
        tempEntityShort: tempShort,
      }));
    }

    if (listName === 'documents') {
      const residency = savedMethods.getValues().client.residency;
      if (entity.hasOwnProperty('authority') && entity.country === 'Беларусь') {
        entity.govAgency = {value: 0, label: entity.authority}
      }
      setState((prev) => ({
        ...prev,
        tempEntity: {
          ..._cloneDeep(entity),
          residency,
          country: {value: 0, label: entity.country},
        },
      }));
      return;
    }

    setState((prev) => ({
      ...prev,
      tempEntity: entity,
    }));
  };

  const handleRemoveEntity = (listName, index) => {
    state[listName].splice(index, 1);
    setState((prev) => ({
      ...prev,
      [listName]: state[listName],
    }));
  };

  const handleAddEntity = (modalFlagName) => {
    const {client} = savedMethods.getValues();

    if (modalFlagName === 'showModalDocs') {
      setState((prev) => ({
        ...prev,
        tempEntity: {residency: client.residency, country: client.citizenship},
        tempEntityShort: {},
      }));
      changeModalState(modalFlagName, true);

      return;
    }

    setState((prev) => ({
      ...prev,
      tempEntity: {},
      tempEntityShort: {},
    }));
    changeModalState(modalFlagName, true);
  };

  const onEntitySubmit = (entity, listName, modalFlagName) => {
    let list = state[listName];
    if (entity.hasOwnProperty('govAgency')) {
      entity.authority = entity.govAgency?.label
    }
    if (entity.active !== undefined) {
      if (entity.active) {
        list.forEach((item) => {
          item.active = false;
        });
      }
    }

    for (let prop in entity) {
      if (entity.hasOwnProperty(prop)) {
        if (entity[prop] instanceof Date) {
          entity[prop] = moment.utc(entity[prop]).format();
        }
      }
    }

    if (!isNaN(state.tempEntity.index)) {
      if ('country' in entity) {
        list[state.tempEntity.index] = {
          ...entity,
          country: entity.country?.label ? entity.country.label : entity.country,
        };

        if (modalFlagName === 'showModalEmployer') {
          list[state.tempEntity.index] = {
            accountingPhone: list[state.tempEntity.index].accountingPhone,
            startDate: list[state.tempEntity.index].startDate,
            endDate: list[state.tempEntity.index].endDate,
            organization: list[state.tempEntity.index].organization,
            phone: list[state.tempEntity.index].phone,
            position: list[state.tempEntity.index].position,
            employerAddress: {
              region: list[state.tempEntity.index].region,
              cityType: list[state.tempEntity.index].cityType,
              city: list[state.tempEntity.index].city,
              streetType: list[state.tempEntity.index].streetType,
              street: list[state.tempEntity.index].street,
              house: list[state.tempEntity.index].house,
              building: list[state.tempEntity.index].building,
              apartment: list[state.tempEntity.index].apartment,
              country: list[state.tempEntity.index].country,
            },
          };
        }
      } else {
        list[state.tempEntity.index] = entity;
      }
    } else {
      if ('country' in entity) {
        entity = {
          ...entity,
          country: entity.country?.label ? entity.country.label : entity.country,
        };

        if (modalFlagName === 'showModalEmployer') {
          entity = {
            accountingPhone: entity.accountingPhone,
            startDate: entity.startDate,
            endDate: entity.endDate,
            organization: entity.organization,
            phone: entity.phone,
            position: entity.position,
            employerAddress: {
              region: entity.region,
              cityType: entity.cityType,
              city: entity.city,
              streetType: entity.streetType,
              street: entity.street,
              house: entity.house,
              building: entity.building,
              apartment: entity.apartment,
              country: entity.country,
            },
          };
        }
      }

      list = state[listName].concat(entity);
    }
    setState((prev) => ({
      ...prev,
      [listName]: list,
    }));
    changeModalState(modalFlagName, false);
  };

  const changeModalState = (name, state) => {
    setState((prev) => ({
      ...prev,
      [name]: state,
    }));
  };

  const handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.id;

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleGoBack = () => {
    dispatch(clearCondition());
    history.goBack();
  };

  const handleOptions = (syl, action) => {
    if (action.action === 'input-change') dispatch(getCountry(syl));
    if (action.action === 'input-blur') dispatch(clearCondition());
  };

  let savedMethods;

  const handleAdditionalChange = (name, value) => {
    const values = savedMethods?.getValues();
    const description = values.client?.description;

    if(description) {
      setDescription(description)
    }

    if(name) {
      setDescription((prev) => ({
        ...prev,
        [name]:  value
      }))
    }
  }

  return (
    <main className="app-content">
      { isLoadingConfiguration ?
        (<div className="content-inner">
            <Loader pageRange={1}/>
          </div>) :
        (<>
          <div className={accessFeatures['title.header_section'] ? '' : 'content-header'}>
          {history.location?.state?.isQuickCalculation ? null : (
            <div className={accessFeatures['title.header_section'] ? 'content-header-back-without-title' : 'content-header-back'}>
              <BackButton handleGoBack={handleGoBack}/>
            </div>
          )}
          {!accessFeatures['title.header_section'] && <h1> Добавление клиента</h1>}
        </div>
        <div className="content-inner">
          <div className="content-inner-data">
            {combineError && <Message type="error" text={combineError}/>}
            <div className="content-inner-data-container">
              <div className={s.content_box}>
                <HookForm
                  onSubmit={onSubmit}
                  validationSchema={createClientScheme(accessFeatures['client.aim_and_relationship'], accessFeatures['client.category'])}
                  defaultValues={{client: {residency: true}}}
                  predef={(methods) => {
                    methods.setValue("expanded.flag", !!state.expanded);
                    savedMethods = methods;
                  }}
                >
                  <Tabs
                    defaultIndex={0}
                    onSelect={(index) => {
                      if (savedMethods) {
                        let values = savedMethods.getValues();
                        values.expanded.flag = index === 1;
                        savedMethods.reset(values);
                      }
                      setState((prev) => ({
                        ...prev,
                        expanded: index === 1,
                      }));
                    }}
                    className="p-t-spacer-2"
                  >
                    <TabList className="content-tabs offset">
                      <Tab className="button-tab" selectedClassName="active">
                        Стандартная форма
                      </Tab>
                      <Tab className="button-tab" selectedClassName="active">
                        Расширенная форма
                      </Tab>
                    </TabList>
                    {loading && <ClientAddLoader/>}
                    <div className={loading ? "d-none" : ""}>
                      <TabPanel>
                        {!state.expanded ? (
                          <>
                            <fieldset className="m-t-spacer-2">
                              <div className="content-section-title">
                                <h3>Идентификационные данные</h3>
                              </div>
                              <ClientInfoAdd
                                h="true"
                                country={country}
                                isLoading={isLoading}
                                handleOptions={handleOptions}
                              />
                              <HCheckbox
                                h="true"
                                id="expanded"
                                defaultValue={true}
                                name="expanded.flag"
                                value={false}
                                hidden
                              />
                            </fieldset>
                            <fieldset>             
                              <FormElementsAdd 
                                h="true"
                                description={description} 
                                currentField={aimAndRelationshipFeature ? CLIENT_FIELDS.OTHER_INFORMATION : CLIENT_FIELDS.DESCRIPTION}
                                handleAdditionalChange={handleAdditionalChange}/> 
                            </fieldset>
                            <fieldset>
                              <div className="content-section-title">
                                <h3>Прочее</h3>
                              </div>
                              <div className="form-row">
                                <div className="form-row-item">
                                  <div className="form-element">
                                    <label
                                      className="form-element-label"
                                      htmlFor="clientWhereKnowAboutUs">
                                      Откуда узнали о нас
                                    </label>
                                    <div className="form-element-data">
                                      <HSelect
                                        h="true"
                                        value={state.hearAbout}
                                        onChange={handleChange}
                                        className="input"
                                        type="text"
                                        name="client.hearAbout"
                                        id="hearAbout"
                                        options={['', ...hearAboutTypes]}
                                      />
                                    </div>
                                  </div>
                                  {state.hearAbout === 'Другое' && (
                                    <div className="form-element">
                                      <label className="form-element-label" htmlFor="hearSource">
                                        Источник
                                      </label>
                                      <div className="form-element-data">
                                        <HInput
                                          h="true"
                                          className="input"
                                          type="text"
                                          name="client.hearSource"
                                          id="hearSource"
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                                {accessFeatures["client.category"] && <div className="form-row-item">
                                  <div className="form-element">
                                    <label
                                      className="form-element-label"
                                      htmlFor="clientCategories">
                                      Категория
                                    </label>
                                    <div className="form-element-data combobox-md">
                                      <DSelect
                                        h="true"
                                        name={`client.categories`}
                                        defaultValue={defaultClientCategories[0]}
                                        options={defaultClientCategories}
                                      />
                                    </div>
                                  </div>
                                </div>}
                                {accessFeatures['client.aim_and_relationship'] &&
                                  <div className="form-row-item">
                                    <div className="form-element">
                                      <label className="form-element-label" htmlFor="#">
                                        Цели установления и характер отношений с ООО «ВИСЕМ»
                                      </label>
                                      <div className="form-element-data">
                                        <HSelect
                                          h="true"
                                          className="input"
                                          type="text"
                                          name="client.aimAndRelationship"
                                          id="aimAndRelationship"
                                          options={['', 'Получение микрозайма']}
                                          defaultValue={'Получение микрозайма'}
                                        />
                                      </div>
                                    </div>
                                  </div>}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Документы</h3>
                                  <div className="content-card-title-actions">
                                    <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalDocs')}>
                                        <span className="icon">
                                        <PlusIcon/>
                                        </span>
                                      <span>Добавить</span>
                                    </button>
                                  </div>
                                </div>
                                {state.documents.length > 0 && (
                                  <div className="content-card-content">
                                    {state.documents.map((document, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('documents', index)}>
                                              <span className="icon">
                                              <TrashIcon/>
                                              </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('documents', index);
                                              changeModalState('showModalDocs', true);
                                            }}>
                                              <span className="icon">
                                              <EditIcon/>
                                              </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <DocumentsView documentInfo={document}/>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Адреса</h3>
                                  <div className="content-card-title-actions">
                                    <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalAddresses')}>
        <span className="icon">
        <PlusIcon/>
        </span>
                                      <span>Добавить</span>
                                    </button>
                                  </div>
                                </div>
                                {state.addresses.length > 0 && (
                                  <div className="content-card-content">
                                    {state.addresses.map((address, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('addresses', index)}>
        <span className="icon">
        <TrashIcon/>
        </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('addresses', index);
                                              changeModalState('showModalAddresses', true);
                                            }}>
        <span className="icon">
        <EditIcon/>
        </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <AddressView
                                            addressInfo={address}
                                            titleApartment={'Квартира'}
                                          />
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Контакты</h3>
                                  <div className="content-card-title-actions">
                                    <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalContacts')}>
        <span className="icon">
        <PlusIcon/>
        </span>
                                      <span>Добавить</span>
                                    </button>
                                  </div>
                                </div>
                                {state.contacts.length > 0 && (
                                  <div className="content-card-content">
                                    {state.contacts.map((contact, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('contacts', index)}>
        <span className="icon">
        <TrashIcon/>
        </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('contacts', index);
                                              changeModalState('showModalContacts', true);
                                            }}>
        <span className="icon">
        <EditIcon/>
        </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <ContactView contactInfo={contact}/>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Служебная информация</h3>
                                  <div className="content-card-title-actions">
                                    {!state.serviceInformation.length && <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalServiceInformation')}>
                                        <span className="icon">
                                        <PlusIcon/>
                                        </span>
                                      <span>Добавить</span>
                                    </button>}
                                  </div>
                                </div>
                                {state.serviceInformation.length > 0 && (
                                  <div className="content-card-content">
                                    {state.serviceInformation.map((serviceInfo, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('serviceInformation', index)}>
                                              <span className="icon">
                                              <TrashIcon/>
                                              </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('serviceInformation', index);
                                              changeModalState('showModalServiceInformation', true);
                                            }}>
                                              <span className="icon">
                                              <EditIcon/>
                                              </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <ServiceInfoView serviceInfo={serviceInfo}/>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                          </>
                        ) : null}
                      </TabPanel>
                      <TabPanel>
                        {state.expanded ? (
                          <>
                            <fieldset className='m-t-spacer-2'>
                              <HCheckbox
                                h="true"
                                id="expanded"
                                defaultValue
                                name="expanded.flag"
                                value
                                hidden
                              />
                              <div className="content-section-title">
                                <h3>Идентификационные данные</h3>
                              </div>
                              <ClientInfoAdd
                                h="true"
                                country={country}
                                isLoading={isLoading}
                                activeTab={state.expanded}
                                handleOptions={handleOptions}
                              />
                            </fieldset>
                            <fieldset>
                            <FormElementsAdd 
                                h="true"
                                description={description} 
                                currentField={aimAndRelationshipFeature ? CLIENT_FIELDS.OTHER_INFORMATION : CLIENT_FIELDS.DESCRIPTION}
                                handleAdditionalChange={handleAdditionalChange}/> 
                            </fieldset>
                            <fieldset>
                              <div className="content-section-title">
                                <h3>Прочее</h3>
                              </div>
                              <div className="form-row">
                                <div className="form-row-item">
                                  <div className="form-element">
                                    <label
                                      className="form-element-label"
                                      htmlFor="clientWhereKnowAboutUs">
                                      Откуда узнали о нас
                                    </label>
                                    <div className="form-element-data">
                                      <HSelect
                                        h="true"
                                        value={state.hearAbout}
                                        onChange={handleChange}
                                        className="input"
                                        type="text"
                                        name="client.hearAbout"
                                        id="hearAbout"
                                        options={['', ...hearAboutTypes]}
                                      />
                                    </div>
                                  </div>
                                  {state.hearAbout === 'Другое' && (
                                    <div className="form-element">
                                      <label className="form-element-label" htmlFor="hearSource">
                                        Источник
                                      </label>
                                      <div className="form-element-data">
                                        <HInput
                                          h="true"
                                          className="input"
                                          type="text"
                                          name="client.hearSource"
                                          id="hearSource"
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                                {accessFeatures["client.category"] && <div className="form-row-item">
                                  <div className="form-element">
                                    <label
                                      className="form-element-label"
                                      htmlFor="clientCategories">
                                      Категория
                                    </label>
                                    <div className="form-element-data combobox-md">
                                      <DSelect
                                        h="true"
                                        name={`client.categories`}
                                        defaultValue={defaultClientCategories[0]}
                                        options={defaultClientCategories}
                                      />
                                    </div>
                                  </div>
                                </div>}
                                {accessFeatures['client.aim_and_relationship'] &&
                                  <div className="form-row-item">
                                    <div className="form-element">
                                      <label className="form-element-label" htmlFor="#">
                                        Цели установления и характер отношений с ООО «ВИСЕМ»
                                      </label>
                                      <div className="form-element-data">
                                        <HSelect
                                          h="true"
                                          className="input"
                                          type="text"
                                          name="client.aimAndRelationship"
                                          id="aimAndRelationship"
                                          options={['', 'Получение микрозайма']}
                                          defaultValue={'Получение микрозайма'}
                                        />
                                      </div>
                                    </div>
                                  </div>}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Документы</h3>
                                  <div className="content-card-title-actions">
                                    <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalDocs')}>
        <span className="icon">
        <PlusIcon/>
        </span>
                                      <span>Добавить</span>
                                    </button>
                                  </div>
                                </div>
                                {state.documents.length > 0 && (
                                  <div className="content-card-content">
                                    {state.documents.map((document, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('documents', index)}>
        <span className="icon">
        <TrashIcon/>
        </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('documents', index);
                                              changeModalState('showModalDocs', true);
                                            }}>
        <span className="icon">
        <EditIcon/>
        </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <DocumentsView documentInfo={document}/>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Адреса</h3>
                                  <div className="content-card-title-actions">
                                    <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalAddresses')}>
        <span className="icon">
        <PlusIcon/>
        </span>
                                      <span>Добавить</span>
                                    </button>
                                  </div>
                                </div>
                                {state.addresses.length > 0 && (
                                  <div className="content-card-content">
                                    {state.addresses.map((address, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('addresses', index)}>
        <span className="icon">
        <TrashIcon/>
        </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('addresses', index);
                                              changeModalState('showModalAddresses', true);
                                            }}>
        <span className="icon">
        <EditIcon/>
        </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <AddressView
                                            addressInfo={address}
                                            titleApartment={'Квартира'}
                                          />
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Контакты</h3>
                                  <div className="content-card-title-actions">
                                    <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalContacts')}>
        <span className="icon">
        <PlusIcon/>
        </span>
                                      <span>Добавить</span>
                                    </button>
                                  </div>
                                </div>
                                {state.contacts.length > 0 && (
                                  <div className="content-card-content">
                                    {state.contacts.map((contact, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('contacts', index)}>
        <span className="icon">
        <TrashIcon/>
        </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('contacts', index);
                                              changeModalState('showModalContacts', true);
                                            }}>
        <span className="icon">
        <EditIcon/>
        </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <ContactView contactInfo={contact}/>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Служебная информация</h3>
                                  <div className="content-card-title-actions">
                                    {!state.serviceInformation.length && <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalServiceInformation')}>
                                        <span className="icon">
                                        <PlusIcon/>
                                        </span>
                                      <span>Добавить</span>
                                    </button>}
                                  </div>
                                </div>
                                {state.serviceInformation.length > 0 && (
                                  <div className="content-card-content">
                                    {state.serviceInformation.map((serviceInfo, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('serviceInformation', index)}>
                                              <span className="icon">
                                              <TrashIcon/>
                                              </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('serviceInformation', index);
                                              changeModalState('showModalServiceInformation', true);
                                            }}>
                                              <span className="icon">
                                              <EditIcon/>
                                              </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <ServiceInfoView serviceInfo={serviceInfo}/>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Сведения о лицах, способных прямо и (или) косвенно (через иных
                                    лиц) определять решения клиента или оказывать влияние на их принятие, а также
                                    лицах, на принятие решений которыми данный клиент оказывает такое влияние (при наличии)
                                  </h3>
                                  <div className="content-card-title-actions">
                                    {!state.decisionMakersInfo.length && <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalDecisionMakersInfo')}>
                                        <span className="icon">
                                        <PlusIcon/>
                                        </span>
                                      <span>Добавить</span>
                                    </button>}
                                  </div>
                                </div>
                                {state.decisionMakersInfo.length > 0 && (
                                  <div className="content-card-content">
                                    {state.decisionMakersInfo.map(({decisionMakersInfo}, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('decisionMakersInfo', index)}>
                                              <span className="icon">
                                              <TrashIcon/>
                                              </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('decisionMakersInfo', index);
                                              changeModalState('showModalDecisionMakersInfo', true);
                                            }}>
                                              <span className="icon">
                                              <EditIcon/>
                                              </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <DecisionMakersInfoView decisionInfo={decisionMakersInfo}/>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Данные о работодателе</h3>
                                  <div className="content-card-title-actions">
                                    <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalEmployer')}>
        <span className="icon">
        <PlusIcon/>
        </span>
                                      <span>Добавить</span>
                                    </button>
                                  </div>
                                </div>
                                {state.employers.length > 0 && (
                                  <div className="content-card-content">
                                    {state.employers.map((employer, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('employers', index)}>
        <span className="icon">
        <TrashIcon/>
        </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('employers', index);
                                              changeModalState('showModalEmployer', true);
                                            }}>
        <span className="icon">
        <EditIcon/>
        </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <EmployerView employerInfo={employer}/>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Сведения о въездной визе</h3>
                                  <div className="content-card-title-actions">
                                    <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalVisa')}>
        <span className="icon">
        <PlusIcon/>
        </span>
                                      <span>Добавить</span>
                                    </button>
                                  </div>
                                </div>
                                {state.entryVisas.length > 0 && (
                                  <div className="content-card-content">
                                    {state.entryVisas.map((entryVisa, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => handleRemoveEntity('entryVisas', index)}>
        <span className="icon">
        <TrashIcon/>
        </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('entryVisas', index);
                                              changeModalState('showModalVisa', true);
                                            }}>
        <span className="icon">
        <EditIcon/>
        </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <VisaView visaInfo={entryVisa}/>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Предыдущие фамилии</h3>
                                  <div className="content-card-title-actions">
                                    <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalPreviousSurname')}>
        <span className="icon">
        <PlusIcon/>
        </span>
                                      <span>Добавить</span>
                                    </button>
                                  </div>
                                </div>
                                {state.previousLastNames.length > 0 && (
                                  <div className="content-card-content">
                                    {state.previousLastNames.map((previousLastName, index) => (
                                      <div className="datacard" key={index}>
                                        <div className="datacard-header">
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() =>
                                              handleRemoveEntity('previousLastNames', index)
                                            }>
        <span className="icon">
        <TrashIcon/>
        </span>
                                            <span>Удалить</span>
                                          </button>
                                          <button
                                            type="button"
                                            className="button-icontrigger caption noborder"
                                            onClick={() => {
                                              handleEditEntity('previousLastNames', index);
                                              changeModalState('showModalPreviousSurname', true);
                                            }}>
        <span className="icon">
        <EditIcon/>
        </span>
                                            <span>Редактировать</span>
                                          </button>
                                        </div>
                                        <div className="datacard-body">
                                          <NamesView namesInfo={previousLastName}/>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                            <fieldset>
                              <div className="content-card">
                                <div className="content-card-title">
                                  <h3>Данные о ИП</h3>
                                  <div className="content-card-title-actions">
                                    <button
                                      type="button"
                                      className="button-icontrigger caption noborder"
                                      onClick={() => handleAddEntity('showModalIE')}>
        <span className="icon">
        <PlusIcon/>
        </span>
                                      <span>Добавить</span>
                                    </button>
                                  </div>
                                </div>
                                {state.individualEntrepreneurs.length > 0 && (
                                  <div className="content-card-content">
                                    {state.individualEntrepreneurs.map(
                                      (individualEntrepreneur, index) => (
                                        <div className="datacard" key={index}>
                                          <div className="datacard-header">
                                            <button
                                              type="button"
                                              className="button-icontrigger caption noborder"
                                              onClick={() =>
                                                handleRemoveEntity('individualEntrepreneurs', index)
                                              }>
        <span className="icon">
        <TrashIcon/>
        </span>
                                              <span>Удалить</span>
                                            </button>
                                            <button
                                              type="button"
                                              className="button-icontrigger caption noborder"
                                              onClick={() => {
                                                handleEditEntity('individualEntrepreneurs', index);
                                                changeModalState('showModalIE', true);
                                              }}>
        <span className="icon">
        <EditIcon/>
        </span>
                                              <span>Редактировать</span>
                                            </button>
                                          </div>
                                          <div className="datacard-body">
                                            <IEView ieInfo={individualEntrepreneur}/>
                                          </div>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                )}
                              </div>
                            </fieldset>
                          </>
                        ) : null}
                      </TabPanel>
                    </div>
                  </Tabs>
                  <div className="content-inner-data-container-footer">
                    <button className="button" type="submit">
                      Добавить клиента
                    </button>
                    <button className="button-light"
                            type="button"
                            onClick={handleGoBack}>
                      Отменить
                    </button>
                  </div>
                </HookForm>
                {criminalResults && <CriminalsInfo data={criminalResults}/>}
              </div>
              <ServiceInformationModal state={state} 
                description={description}
                aimAndRelationshipFeature={aimAndRelationshipFeature}
                handleAdditionalChange={handleAdditionalChange}
                changeModalState={changeModalState} 
                onSubmit={onEntitySubmit}/>
              <ReactModal
                isOpen={state.showModalDecisionMakersInfo}
                contentLabel="Modal"
                className="modal-container document-modal"
                overlayClassName="modal-overlay">
                <HookForm
                  onSubmit={(entity) => onEntitySubmit(entity, 'decisionMakersInfo', 'showModalDecisionMakersInfo')}
                  validationSchema={clientDecisionMakersInfoScheme}
                  defaultValues={state.tempEntity}>
                  <div className="modal-header">
                    <h2>
                      {isNaN(state.tempEntity.index)
                        ? 'Добавить '
                        : 'Редактировать'}
                        cведения о лицах, способных прямо и (или) косвенно (через иных лиц) определять решения клиента или оказывать влияние на их принятие, а также лицах, на принятие решений которыми данный клиент оказывает такое влияние (при наличии)
                    </h2>
                    <button
                      className="button-icontrigger modal-closetrigger"
                      onClick={() => changeModalState('showModalDecisionMakersInfo', false)}>
                        <span className="icon"><CrossIcon/></span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <DecisionMakersInfoAdd h="true" decisionInfo={state.tempEntity?.decisionMakersInfo}/>
                  </div>
                  <div className="modal-footer">
                    <button className="button" type="submit">
                      {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
                    </button>
                    <button
                      className="button-light"
                      onClick={() => changeModalState('showModalDecisionMakersInfo', false)}>
                      Отменить
                    </button>
                  </div>
                </HookForm>
              </ReactModal>
              <ReactModal
                isOpen={state.showModalDocs}
                contentLabel="Modal"
                className="modal-container document-modal"
                overlayClassName="modal-overlay">
                <HookForm
                  onSubmit={(entity) => onEntitySubmit(entity, 'documents', 'showModalDocs')}
                  validationSchema={clientDocumentScheme}
                  defaultValues={state.tempEntity}
                  submitOnEnterPress={true}>
                  <div className="modal-header">
                    <h2>
                      {isNaN(state.tempEntity.index)
                        ? 'Добавить документ'
                        : 'Редактировать документ'}
                    </h2>
                    <button
                      className="button-icontrigger modal-closetrigger"
                      onClick={() => changeModalState('showModalDocs', false)}>
        <span className="icon">
        <CrossIcon/>
        </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <DocumentsAdd
                      h="true"
                      country={country}
                      isLoading={isLoading}
                      handleOptions={handleOptions}
                      tempEntity={state.tempEntity}
                    />
                  </div>
                  <div className="modal-footer">
                    <button className="button" type="submit">
                      {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
                    </button>
                    <button
                      className="button-light"
                      onClick={() => changeModalState('showModalDocs', false)}>
                      Отменить
                    </button>
                  </div>
                </HookForm>
              </ReactModal>
              <ReactModal
                isOpen={state.showModalAddresses}
                contentLabel="Modal"
                className="modal-container visible-modal"
                overlayClassName="modal-overlay">
                <HookForm
                  onSubmit={(entity) => onEntitySubmit(entity, 'addresses', 'showModalAddresses')}
                  validationSchema={clientAddressScheme}
                  defaultValues={state.addressTabIndex === 0 ? state.tempEntity : state.tempEntityShort}
                  submitOnEnterPress={true}>
                  <div className="modal-header">
                    <h2>
                      {isNaN(state.tempEntity.index) ? 'Добавить адрес' : 'Редактировать адрес'}
                    </h2>
                    <button
                      className="button-icontrigger modal-closetrigger"
                      onClick={() => changeModalState('showModalAddresses', false)}>
        <span className="icon">
        <CrossIcon/>
        </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <AddressShortAdd h="true" tempEntity={state.tempEntityShort}/>
                  </div>
                  <div className="modal-footer">
                    <button className="button">
                      {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
                    </button>
                    <button
                      className="button-light"
                      onClick={() => changeModalState('showModalAddresses', false)}>
                      Отменить
                    </button>
                  </div>
                </HookForm>
              </ReactModal>
              <ReactModal
                isOpen={state.showModalContacts}
                contentLabel="Modal"
                className="modal-container"
                overlayClassName="modal-overlay">
                <HookForm
                  onSubmit={(entity) => onEntitySubmit(entity, 'contacts', 'showModalContacts')}
                  validationSchema={clientContactScheme}
                  defaultValues={state.tempEntity}
                  submitOnEnterPress={true}
                >
                  <div className="modal-header">
                    <h2>
                      {isNaN(state.tempEntity.index)
                        ? 'Добавить контактные данные'
                        : 'Редактировать контактные данные'}
                    </h2>
                    <button
                      className="button-icontrigger modal-closetrigger"
                      onClick={() => changeModalState('showModalContacts', false)}>
        <span className="icon">
        <CrossIcon/>
        </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <ContactsAdd h="true"/>
                  </div>
                  <div className="modal-footer">
                    <button className="button">
                      {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
                    </button>
                    <button
                      className="button-light"
                      onClick={() => changeModalState('showModalContacts', false)}>
                      Отменить
                    </button>
                  </div>
                </HookForm>
              </ReactModal>
              <ReactModal
                isOpen={state.showModalEmployer}
                contentLabel="Modal"
                className="modal-container clientAdd-modal"
                overlayClassName="modal-overlay">
                <HookForm
                  onSubmit={(entity) => onEntitySubmit(entity, 'employers', 'showModalEmployer')}
                  validationSchema={clientEmployerScheme}
                  defaultValues={state.tempEntity}
                  submitOnEnterPress={true}
                >
                  <div className="modal-header">
                    <h2>
                      {isNaN(state.tempEntity.index)
                        ? 'Добавить данные о работодателе'
                        : 'Редактировать данные о работодателе'}
                    </h2>
                    <button
                      className="button-icontrigger modal-closetrigger"
                      onClick={() => changeModalState('showModalEmployer', false)}>
        <span className="icon">
        <CrossIcon/>
        </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <EmployerAdd
                      h="true"
                      country={country}
                      isLoading={isLoading}
                      handleOptions={handleOptions}
                      tempEntity={state.tempEntity}
                    />
                  </div>
                  <div className="modal-footer">
                    <button className="button">
                      {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
                    </button>
                    <button
                      className="button-light"
                      onClick={() => changeModalState('showModalEmployer', false)}>
                      Отменить
                    </button>
                  </div>
                </HookForm>
              </ReactModal>
              <ReactModal
                isOpen={state.showModalVisa}
                contentLabel="Modal"
                className="modal-container"
                overlayClassName="modal-overlay">
                <HookForm
                  onSubmit={(entity) => onEntitySubmit(entity, 'entryVisas', 'showModalVisa')}
                  validationSchema={clientVisaScheme}
                  defaultValues={state.tempEntity}
                  submitOnEnterPress={true}>
                  <div className="modal-header">
                    <h2>
                      {isNaN(state.tempEntity.index)
                        ? 'Добавить сведения о въездной визе'
                        : 'Редактировать сведения о въездной визе'}
                    </h2>
                    <button
                      className="button-icontrigger modal-closetrigger"
                      onClick={() => changeModalState('showModalVisa', false)}>
        <span className="icon">
        <CrossIcon/>
        </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <VisaAdd
                      h="true"
                      country={country}
                      isLoading={isLoading}
                      handleOptions={handleOptions}
                      tempEntity={state.tempEntity}
                    />
                  </div>
                  <div className="modal-footer">
                    <button className="button">
                      {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
                    </button>
                    <button
                      className="button-light"
                      onClick={() => changeModalState('showModalVisa', false)}>
                      Отменить
                    </button>
                  </div>
                </HookForm>
              </ReactModal>
              <ReactModal
                isOpen={state.showModalRepresentative}
                contentLabel="Modal"
                className="modal-container"
                overlayClassName="modal-overlay">
                <HookForm
                  onSubmit={(entity) =>
                    onEntitySubmit(entity, 'representatives', 'showModalRepresentative')
                  }
                  validationSchema={clientNamesScheme}
                  defaultValues={state.tempEntity}
                  submitOnEnterPress={true}>
                  <div className="modal-header">
                    <h2>
                      {isNaN(state.tempEntity.index)
                        ? 'Добавить представителя'
                        : 'Редактировать представителя'}
                    </h2>

                    <button
                      className="button-icontrigger modal-closetrigger"
                      onClick={() => changeModalState('showModalRepresentative', false)}>
        <span className="icon">
        <CrossIcon/>
        </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <NamesAdd h="true"/>
                  </div>
                  <div className="modal-footer">
                    <button className="button">
                      {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
                    </button>
                    <button
                      className="button-light"
                      onClick={() => changeModalState('showModalRepresentative', false)}>
                      Отменить
                    </button>
                  </div>
                </HookForm>
              </ReactModal>
              <ReactModal
                isOpen={state.showModalPreviousSurname}
                contentLabel="Modal"
                className="modal-container"
                overlayClassName="modal-overlay">
                <HookForm
                  onSubmit={(entity) =>
                    onEntitySubmit(entity, 'previousLastNames', 'showModalPreviousSurname')
                  }
                  validationSchema={clientNamesScheme}
                  defaultValues={state.tempEntity}
                  submitOnEnterPress={true}>
                  <div className="modal-header">
                    <h2>
                      {isNaN(state.tempEntity.index)
                        ? 'Добавить предыдущую фамилию'
                        : 'Редактировать предыдущую фамилию'}
                    </h2>
                    <button
                      className="button-icontrigger modal-closetrigger"
                      onClick={() => changeModalState('showModalPreviousSurname', false)}>
        <span className="icon">
        <CrossIcon/>
        </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <NamesAdd h="true"/>
                  </div>
                  <div className="modal-footer">
                    <button className="button">
                      {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
                    </button>
                    <button
                      className="button-light"
                      onClick={() => changeModalState('showModalPreviousSurname', false)}>
                      Отменить
                    </button>
                  </div>
                </HookForm>
              </ReactModal>
              <ReactModal
                isOpen={state.showModalIE}
                contentLabel="Modal"
                className="modal-container"
                overlayClassName="modal-overlay">
                <HookForm
                  onSubmit={(entity) =>
                    onEntitySubmit(entity, 'individualEntrepreneurs', 'showModalIE')
                  }
                  validationSchema={clientIEScheme}
                  defaultValues={state.tempEntity}>
                  <div className="modal-header">
                    <h2>
                      {isNaN(state.tempEntity.index)
                        ? 'Добавить данные о ИП'
                        : 'Редактировать данные о ИП'}
                    </h2>

                    <button
                      className="button-icontrigger modal-closetrigger"
                      onClick={() => changeModalState('showModalIE', false)}>
        <span className="icon">
        <CrossIcon/>
        </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <IEAdd h="true"/>
                  </div>
                  <div className="modal-footer">
                    <button className="button">
                      {isNaN(state.tempEntity.index) ? 'Добавить' : 'Сохранить'}
                    </button>
                    <button
                      className="button-light"
                      onClick={() => changeModalState('showModalIE', false)}>
                      Отменить
                    </button>
                  </div>
                </HookForm>
              </ReactModal>
            </div>
          </div>
        </div>
      </>)
      }
    </main>
  );
};

export default ClientAdd;
